enum LotFileTypes {
  NONE = 0,
  IMAGE = 1,
  VIDEO = 2,
  PDF = 3
}

export default LotFileTypes;
